import React from 'react'
import { Icon } from "@material-ui/core";
import KeycloakLogo from './keycloak.svg'

export const KeycloakIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: KeycloakLogo, alt: "", height: 25, width: 25,})
    )
)